// Use runtime config (window._env_) if available, otherwise fall back to build-time or default
export const API_BASE_URL = (window._env_ && window._env_.REACT_APP_DOMAIN_NAME) || process.env.REACT_APP_DOMAIN_NAME || "https://api.shadow.homeshiksha.com/";
